import { Menu } from './menu';

export const MenuItems: Menu[] = [
  {
    icon: 'rocket',
    text: 'Operaciones',
    link: '/operations',
  },
  {
    icon: 'show_chart',
    text: 'Historial',
    link: '/histories',
  },
];
